import classNames from 'classnames';
import { SortableElement } from 'react-sortable-hoc';
import { type CFMediaDoc, ImageType } from '@types';
import Image from '@components/Image';
import IconTrash from '@components/icons/IconTrash';
import IconDoc from './icon-doc.png';

interface Props {
  data: CFMediaDoc;
  listIndex: number;
  onDelete: (index: number) => void;
}

function CDocItem({ data, listIndex, onDelete }: Props) {
  const { mediaName, mediaThumb } = data;

  return (
    <div
      className={classNames(
        'relative mb-10 flex h-35 select-none items-center rounded bg-black-border px-10'
      )}
    >
      <div className="h-16 w-16 flex-shrink-0 bg-black">
        <Image
          className="h-16 w-16"
          src={mediaThumb === '' ? IconDoc : mediaThumb}
          type={mediaThumb === '' ? undefined : ImageType.media}
        />
      </div>
      <div className="mx-5 flex-grow truncate text-base text-white">
        {mediaName}
      </div>
      <IconTrash
        className="flex-shrink-0"
        onClick={() => onDelete(listIndex)}
      />
    </div>
  );
}

export default SortableElement(CDocItem);
